

const zmfilter = {
    nubFormat0:function (value) {
        if (!value) {
            return '0';
        }
        return (value).toFixed(0).replace(/(\d)(?=(\d{3})+\.)/g, '$1,');
    },
    nubFormat1:function (value) {
        if (!value) {
            return '0.0';
        }
        return (value).toFixed(1).replace(/(\d)(?=(\d{3})+\.)/g, '$1,');
    },
    nubFormat2:function (value) {
        if (!value) {
            return '0.00';
        }
        return (value).toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, '$1,');
    },
    nubFormat2null:function (value) {
        if (!value) {
            return '';
        }
        return (value).toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, '$1,');
    },
    nubFormat2Not0:function (value) {
        if (!value && value!=0) {
            return '';
        }else if(value==0){
            return '0.00';
        }
        return (value).toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, '$1,');
    },
    nubFormat3:function (value) {
        if (!value) {
            return '0';
        }
        return (value).toFixed(3).replace(/(\d)(?=(\d{3})+\.)/g, '$1,');
    },
    nubFormat4:function (value) {
        if (!value) {
            return '0';
        }
        return (value).toFixed(4).replace(/(\d)(?=(\d{3})+\.)/g, '$1,');
    },
    tipContentFilter:function (str) {
        if (!str) {
            return '';
        }
        let returnStr = '';
        let ss = str.split(/[\n,]/g);
        if(ss && ss.length > 0){
            for(let i = 0;i<ss.length;i++){
                if( i !== 0){
                    returnStr += '</br>';
                }
                returnStr += ss[i];
            }
        }
        return returnStr;
    }


}

export default zmfilter;


// WEBPACK FOOTER //
// /home/jenkins/.jenkins/workspace/tms-saas/code/tms-front/test/tms-front/src/utils/zmFilter.js